import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { useDialogContext } from '@/shared/components/Modal/DialogContext'
import { useSubscription } from '@/shared/components/Subscription/SubscriptionContext'
import { SubscriptionUpgradeDialog } from '@/shared/components/Subscription/SubscriptionUpgradeDialog'

export type RunsheetProtectedRouteProps = {
  children: React.ReactNode
}

export const RunsheetProtectedRoute: React.FC<RunsheetProtectedRouteProps> = ({ children }) => {
  const navigate = useNavigate()
  const { openDialog } = useDialogContext()
  const { canAccessRunsheet } = useSubscription()

  useEffect(() => {
    if (!canAccessRunsheet()) {
      openDialog(SubscriptionUpgradeDialog, {
        feature: 'Runsheet Operations',
        reason: 'Runsheet functionality is available on Premium and Enterprise plans.',
        onClose: () => {
          navigate('/operations/planning', { replace: true })
        },
      })
    }
  }, [canAccessRunsheet, openDialog, navigate])

  if (!canAccessRunsheet()) {
    return null
  }

  return <>{children}</>
}